"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageableFactory = void 0;
class PageableFactory {
    static sample(elements, pageSpec = {}) {
        const size = pageSpec.size || 30;
        const totalElements = pageSpec.totalElements || elements.length;
        return {
            pageSpec: {
                number: 0,
                totalPages: Math.ceil(totalElements / size),
                size,
                totalElements,
                ...pageSpec,
            },
            page: [...elements],
        };
    }
}
exports.PageableFactory = PageableFactory;
//# sourceMappingURL=PageableFactory.js.map